import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Paper,
  TextField,
  Typography,
  Alert,
} from '@mui/material';
import { fetchSheetRange } from '../../../services/sheetValues';
import {
  isInversorAuthenticated,
  setInversorSession,
} from '../../../utils/authSession';
import './Login.css';

const USUARIOS_RANGE = 'Usuarios!B1:C500';

function normalizeCell(v) {
  if (v == null || v === undefined) return '';
  return String(v).trim();
}

export default function Login() {
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isInversorAuthenticated()) {
      navigate('/dashboard', { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const u = normalizeCell(usuario);
    const p = normalizeCell(password);
    if (!u || !p) {
      setError('Introduce usuario y contraseña.');
      return;
    }
    setLoading(true);
    try {
      const rows = await fetchSheetRange(USUARIOS_RANGE);
      const ok = rows.some(
        (row) =>
          normalizeCell(row[0]) === u && normalizeCell(row[1]) === p
      );
      if (ok) {
        setInversorSession(u);
        navigate('/dashboard', { replace: true });
      } else {
        setError('Usuario o contraseña incorrectos.');
      }
    } catch {
      setError(
        'No se pudo validar el acceso. Comprueba la hoja Usuarios y la API de Sheets.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="login-page">
      <Container maxWidth="sm" className="login-container">
        <Paper elevation={3} className="login-paper">
          <Typography variant="h5" component="h1" gutterBottom align="center">
            Acceso inversores
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 2 }}>
            Inicia sesión para ver el panel de inversiones en inmuebles.
          </Typography>
          {error ? (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          ) : null}
          <Box component="form" onSubmit={handleSubmit} noValidate>
            <TextField
              margin="normal"
              required
              fullWidth
              id="usuario"
              label="Usuario"
              name="usuario"
              autoComplete="username"
              autoFocus
              value={usuario}
              onChange={(e) => setUsuario(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Contraseña"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 2, mb: 1 }}
              disabled={loading}
            >
              {loading ? 'Comprobando…' : 'Entrar'}
            </Button>
            <Typography align="center" variant="body2">
              <Link to="/" className="login-back">
                Volver al sitio
              </Link>
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
